


















import { Vue, Prop, Component } from 'vue-property-decorator';

/**
 * 画像4枚 + 縦横ヘッダーレイアウトのインストラクション画像
 */
@Component
export default class CameraPageIntroductionPcBookImages extends Vue {
  get shootType(): 'first' | 'diagonal' | 'second' | null {
    if (this.$store.getters['camera/isIdDocFront']) return 'first';
    if (this.$store.getters['camera/isIdDocBack']) return 'second';
    if (this.$store.getters['camera/isIdDocDiagonal']) return 'diagonal';

    return null;
  }

  readonly src = {
    first: [
      [
        '/img/introduction/identity-document/pc_general_book_first_vertical@1x.png',
        '/img/introduction/identity-document/pc_general_book_first_vertical@2x.png'
      ],
      [
        '/img/introduction/identity-document/tablet_general_book_first_vertical@1x.png',
        '/img/introduction/identity-document/tablet_general_book_first_vertical@2x.png'
      ],
      [
        '/img/introduction/identity-document/pc_general_book_first_horizontal@1x.png',
        '/img/introduction/identity-document/pc_general_book_first_horizontal@2x.png'
      ],
      [
        '/img/introduction/identity-document/tablet_general_book_first_horizontal@1x.png',
        '/img/introduction/identity-document/tablet_general_book_first_horizontal@2x.png'
      ]
    ],
    diagonal: [
      [
        '/img/introduction/identity-document/pc_general_book_diagonal_vertical@1x.png',
        '/img/introduction/identity-document/pc_general_book_diagonal_vertical@2x.png'
      ],
      [
        '/img/introduction/identity-document/tablet_general_book_diagonal_vertical@1x.png',
        '/img/introduction/identity-document/tablet_general_book_diagonal_vertical@2x.png'
      ],
      [
        '/img/introduction/identity-document/pc_general_book_diagonal_horizontal@1x.png',
        '/img/introduction/identity-document/pc_general_book_diagonal_horizontal@2x.png'
      ],
      [
        '/img/introduction/identity-document/tablet_general_book_diagonal_horizontal@1x.png',
        '/img/introduction/identity-document/tablet_general_book_diagonal_horizontal@2x.png'
      ]
    ],
    second: [
      [
        '/img/introduction/identity-document/pc_general_book_second_vertical@1x.png',
        '/img/introduction/identity-document/pc_general_book_second_vertical@2x.png'
      ],
      [
        '/img/introduction/identity-document/tablet_general_book_second_vertical@1x.png',
        '/img/introduction/identity-document/tablet_general_book_second_vertical@2x.png'
      ],
      [
        '/img/introduction/identity-document/pc_general_book_second_horizontal@1x.png',
        '/img/introduction/identity-document/pc_general_book_second_horizontal@2x.png'
      ],
      [
        '/img/introduction/identity-document/tablet_general_book_second_horizontal@1x.png',
        '/img/introduction/identity-document/tablet_general_book_second_horizontal@2x.png'
      ]
    ]
  } as const;
}
